import type { ComponentPropsWithoutRef } from 'react';
import React from 'react';
import type { Breakpoint } from '@noths/polaris-client-ribbons-base';
import { minBreakpoints } from '@noths/polaris-client-ribbons-base';

export interface PictureSourceProps extends ComponentPropsWithoutRef<'source'> {
  height?: number;
  minBreakpoint: Breakpoint;
  srcSet: string;
  width?: number;
}

export const PictureSource = ({ height, minBreakpoint, srcSet, width }: PictureSourceProps) => (
  <source
    height={height}
    key={minBreakpoint}
    media={`(min-width: ${minBreakpoints[minBreakpoint]}px)`}
    srcSet={srcSet}
    width={width}
  />
);
